import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_config_hdr_RowClass} from '../../../dbschema/bl_fi_config_hdr.model';
import {bl_fi_config_ext_RowClass} from '../../../dbschema/bl_fi_config_ext';


export class FinancialConfigContainerModel extends BaseContainerModel {
  bl_fi_config_hdr: bl_fi_config_hdr_RowClass = new bl_fi_config_hdr_RowClass();
  bl_fi_config_exts: bl_fi_config_ext_RowClass[] = [];
}
